<template>
    <div class="block-share">
        <ui-social class="block-share__button" type="vk" @click.native="share('vk')" />
        <ui-social class="block-share__button" type="fb" @click.native="share('fb')" />
        <ui-social class="block-share__button" type="tw" @click.native="share('tw')" />
        <ui-social class="block-share__button" type="ok" @click.native="share('ok')" />
    </div>
</template>

<script>
import Share from '@/utils/share.js'
import Analytics from '@/utils/analytics.js'

const shareData = {
    url: 'https://specials.pikabu.ru/pik/timeline/',
    title: 'Таймлайн растущего ребенка',
    image: 'https://cs.specials.pikabu.ru/pik/timeline/share.png',
    description: 'Пикабу и ПИК прослеживают жизнь ребенка от рождения и до момента, когда он поступает в вуз',
    pixels: {
        ok: 'https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cqdll&pfb=hgjlr&pr=%random%&ptrc=b',
        fb: 'https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cqdll&pfb=hgjlm&pr=%random%&ptrc=b',
        tw: 'https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cqdll&pfb=hgjlt&pr=%random%&ptrc=b',
        vk: 'https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cqdll&pfb=hgjll&pr=%random%&ptrc=b'
    }
};

export default {
    props: {
        link: {
            type: String,
            default: shareData.url
        },
        image: {
            type: String,
            default: shareData.image
        }
    },
    methods: {
        share (type) {
            Share.open(type, shareData)
            Analytics.getPixel(shareData.pixels[type])
        }
    }
}
</script>

<style lang="stylus" scoped>
    .block-share {
        display flex
        justify-content flex-end
        margin 2rem 0

        +layout-md-and-up() {
            margin 2.7rem 0
        }

        &__button {
            margin-right 1.3rem
        }
    }
</style>
